import React from 'react';
import { funFacts } from 'Settings/fun-facts';

import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class LoadingFacts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      facts: funFacts[props.slug].items,
      factsSeen: [],
      activeFact: null,
    };

    this.refreshTimeout = null;
    this.loadNextFact = this.loadNextFact.bind(this);
    this.getFactIndex = this.getFactIndex.bind(this);
  }

  componentDidMount() {
    this.loadNextFact();
  }

  componentDidUpdate() {
    if (!this.props.okayToRefresh) {
      window.clearTimeout(this.refreshTimeout);
    }
  }

  componentWillUnmount() {
    window.clearTimeout(this.refreshTimeout);
  }

  getFactIndex() {
    const { facts, factsSeen } = this.state;
    const nextIndex = Math.floor(Math.random() * Math.floor(facts.length));
    if (factsSeen.includes(nextIndex)) this.getFactIndex();
    return nextIndex;
  }

  loadNextFact() {
    const { facts, factsSeen } = this.state;
    if (facts.length === factsSeen.length) {
      window.clearTimeout(this.refreshTimeout);
      return;
    }
    const nextIndex = this.getFactIndex();
    const activeFact = facts[nextIndex];
    if (!activeFact.emoji)
      activeFact.emoji = funFacts[this.props.slug]['default-emojis'];
    this.setState({
      activeFact,
      factsSeen: [...factsSeen, nextIndex],
    });
    let timeoutLength = Math.floor((activeFact.length / 7) * 1000);
    if (timeoutLength < 7000) timeoutLength = 7000;
    this.refreshTimeout = window.setTimeout(this.loadNextFact, timeoutLength);
  }

  render() {
    const { activeFact } = this.state;
    if (!activeFact) return null;
    return [
      <div className="GameLoading__fact-title" key="title">
        Did you know?
      </div>,
      <div className="GameLoading__emoji" key="emoji">
        {activeFact.emoji}
      </div>,
      <div className="GameLoading__quote" key="quote">
        <ConnectedFormattedMessage id={activeFact.stringId} />
      </div>,
    ];
  }
}

export default LoadingFacts;
